var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.630683 2.72873L7.40175 9.49981L0.630715 16.2708C0.418853 16.4828 0.299805 16.7702 0.299805 17.0699C0.299805 17.3696 0.41881 17.657 0.630651 17.8689C0.842596 18.0808 1.13002 18.1998 1.42971 18.1998C1.7294 18.1998 2.01682 18.0808 2.22877 17.8689L8.99981 11.0979L15.7708 17.8689C15.9828 18.0808 16.2702 18.1998 16.5699 18.1998C16.8696 18.1998 17.157 18.0808 17.3689 17.869C17.5807 17.657 17.6998 17.3696 17.6998 17.0699C17.6998 16.7702 17.5808 16.4828 17.3689 16.2708L10.5979 9.49981L17.3689 2.72877C17.5808 2.51682 17.6998 2.2294 17.6998 1.92971C17.6998 1.63002 17.5808 1.3426 17.3689 1.13065C17.157 0.91881 16.8696 0.799805 16.5699 0.799805C16.2702 0.799805 15.9828 0.918821 15.7709 1.13068L8.99981 7.90175L2.22877 1.13071C2.01682 0.918853 1.72938 0.799805 1.42971 0.799805C1.13005 0.799805 0.842654 0.918809 0.630715 1.13065C0.418873 1.34259 0.299805 1.63005 0.299805 1.92971C0.299805 2.22938 0.418821 2.51679 0.630683 2.72873Z",
    fill: "#8B8B8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.368b0ba773e6b8e0e88b2d7bdbb17b02.svg";
export { ForwardRef as ReactComponent };